define('viewModels/privileged/callbacks/ScheduledCallbackRow',[
    'lib/knockout',
    'lib/lodash4',
    'models/AnalyticsConversation',
    'viewModels/privileged/callbacks/ScheduledCallbackActions',
    'viewModels/ViewModel',
    // no reference required
    'extensions/i18n/knockout.i18n'
], function (
    ko,
    _,
    AnalyticsConversation,
    ScheduledCallbackActions,
    ViewModel
) {
    'use strict';

    var earlierScheduledSegment = function (earliestScheduledSegment, segment) {
        return earliestScheduledSegment.session().callbackScheduledTime().isBefore(segment.session().callbackScheduledTime()) ?
            earliestScheduledSegment : segment;
    };

    return ViewModel.extend(function (scheduledCallbacks, analyticsConversation) {
        var self = this;

        self.callbackUserName = ko.observable();
        self.callbackNumbers = ko.observable();
        self.callbackScheduledTime = ko.observable();
        self.divisionIds = ko.observableArray();
        self.queueId = ko.observable();
        self.campaignId = ko.observable();
        self.divisionNames = ko.observable();
        self.queueName = ko.observable();
        self.campaignName = ko.observable();

        self.analyticsConversation = new AnalyticsConversation(analyticsConversation);
        var allSessions = _.flatMap(self.analyticsConversation.participants(), function (participant) {
            return participant.sessions();
        });
        var allSegments = _.flatMap(allSessions, function (session) {
            return session.segments();
        });
        var scheduledSegments = _.filter(allSegments, function (segment) {
            return segment.session().callbackScheduledTime() &&
                   _.toLower(segment.segmentType()) === 'scheduled' &&
                   !segment.segmentEnd();
        });
        var earliestScheduledSegment = _(scheduledSegments)
            .tail().reduce(earlierScheduledSegment, _.first(scheduledSegments));

        if (earliestScheduledSegment) {
            self.callbackUserName(earliestScheduledSegment.session().callbackUserName());
            self.callbackNumbers(earliestScheduledSegment.session().callbackNumbers());
            self.callbackScheduledTime(earliestScheduledSegment.session().callbackScheduledTime().toDate());

            if (earliestScheduledSegment.queueId()) {
                self.queueId(earliestScheduledSegment.queueId());
            } else {
                // if there is a scheduled callback on a dialer system participant, we should look for a queueId associated with a campaign
                var earliestScheduledDialerSystem = _.find(scheduledSegments, function (segment) {
                    return earliestScheduledSegment.session().callbackScheduledTime().isSame(segment.session().callbackScheduledTime()) &&
                           _.toLower(segment.participant().purpose()) === 'dialersystem';
                });

                if (earliestScheduledDialerSystem) {
                    var segmentWithQueueId = _.find(allSegments, function (segment) {
                        return segment.session().outboundCampaignId() && segment.queueId();
                    });

                    if (segmentWithQueueId) {
                        self.queueId(segmentWithQueueId.queueId());
                    }
                }
            }
        }

        self.divisionIds(self.analyticsConversation.divisionIds());

        self.campaignId(ko.unwrap(_.chain(allSessions)
            .find('outboundCampaignId')
            .get('outboundCampaignId')
            .value()));

        self.formattedCallbackNumbers = self.computed(function () {
            return _.map(self.callbackNumbers(), ko.i18n.formatPhoneAddress);
        });

        self.actions = self.subView(ScheduledCallbackActions, scheduledCallbacks, self.analyticsConversation);
    });
});
